/**
 * Generated from ch9_p05.fla
 */
export function ch9_p05(this: Ich9_p05) {
	const bg = this.bg;
	if (!bg[0] && bg.elementFactory) {
		bg[0] = bg.elementFactory(0,undefined);
	}
	if (bg[0]) {
		ch9_p05_hh_ch9_72dpi_p05psdAssetchp9_p05_bgcopy.call(bg[0] as Ich9_p05_hh_ch9_72dpi_p05psdAssetchp9_p05_bgcopy);
		bg[0].x = 1024;
		bg[0].y = 384;
		bg[0].width = 2048.00;
		bg[0].height = 768.00;
		bg[0].alpha = 1;
		if (bg[0].onLayout) bg[0].onLayout();
	}
	if (!bg[1] && bg.elementFactory) {
		bg[1] = bg.elementFactory(1,undefined);
	}
	if (bg[1]) {
		ch9_p05_hh_ch9_72dpi_p05psdAssetchp9_p05_bg.call(bg[1] as Ich9_p05_hh_ch9_72dpi_p05psdAssetchp9_p05_bg);
		bg[1].x = 2688;
		bg[1].y = 384;
		bg[1].width = 1280.00;
		bg[1].height = 768.00;
		bg[1].alpha = 1;
		if (bg[1].onLayout) bg[1].onLayout();
	}
	const lanternBack = this.lanternBack;
	if (!lanternBack[0] && lanternBack.elementFactory) {
		lanternBack[0] = lanternBack.elementFactory(0,undefined);
	}
	if (lanternBack[0]) {
		ch9_p05_lanternYellow.call(lanternBack[0] as Ich9_p05_lanternYellow);
		lanternBack[0].x = 971.85;
		lanternBack[0].y = 598.85;
		if (lanternBack[0].scale) lanternBack[0].scale.x = 0.700;
		if (lanternBack[0].scale) lanternBack[0].scale.y = 0.700;
		if (lanternBack[0].onLayout) lanternBack[0].onLayout();
	}
	if (!lanternBack[1] && lanternBack.elementFactory) {
		lanternBack[1] = lanternBack.elementFactory(1,undefined);
	}
	if (lanternBack[1]) {
		ch9_p05_lanternBlue.call(lanternBack[1] as Ich9_p05_lanternBlue);
		lanternBack[1].x = 1426.55;
		lanternBack[1].y = 591.8;
		if (lanternBack[1].scale) lanternBack[1].scale.x = -0.703;
		if (lanternBack[1].scale) lanternBack[1].scale.y = 0.703;
		if (lanternBack[1].onLayout) lanternBack[1].onLayout();
	}
	if (!lanternBack[2] && lanternBack.elementFactory) {
		lanternBack[2] = lanternBack.elementFactory(2,undefined);
	}
	if (lanternBack[2]) {
		ch9_p05_lanternRed.call(lanternBack[2] as Ich9_p05_lanternRed);
		lanternBack[2].x = 1663.4;
		lanternBack[2].y = 592.7;
		if (lanternBack[2].scale) lanternBack[2].scale.x = 0.800;
		if (lanternBack[2].scale) lanternBack[2].scale.y = 0.800;
		if (lanternBack[2].onLayout) lanternBack[2].onLayout();
	}
	if (!lanternBack[3] && lanternBack.elementFactory) {
		lanternBack[3] = lanternBack.elementFactory(3,undefined);
	}
	if (lanternBack[3]) {
		ch9_p05_lanternYellow.call(lanternBack[3] as Ich9_p05_lanternYellow);
		lanternBack[3].x = 1846.65;
		lanternBack[3].y = 591.8;
		if (lanternBack[3].scale) lanternBack[3].scale.x = 0.700;
		if (lanternBack[3].scale) lanternBack[3].scale.y = 0.700;
		if (lanternBack[3].onLayout) lanternBack[3].onLayout();
	}
	if (!lanternBack[4] && lanternBack.elementFactory) {
		lanternBack[4] = lanternBack.elementFactory(4,undefined);
	}
	if (lanternBack[4]) {
		ch9_p05_lanternBlue.call(lanternBack[4] as Ich9_p05_lanternBlue);
		lanternBack[4].x = 2008.3;
		lanternBack[4].y = 619.35;
		if (lanternBack[4].scale) lanternBack[4].scale.x = -0.700;
		if (lanternBack[4].scale) lanternBack[4].scale.y = 0.700;
		if (lanternBack[4].onLayout) lanternBack[4].onLayout();
	}
	if (!lanternBack[5] && lanternBack.elementFactory) {
		lanternBack[5] = lanternBack.elementFactory(5,undefined);
	}
	if (lanternBack[5]) {
		ch9_p05_lanternRed.call(lanternBack[5] as Ich9_p05_lanternRed);
		lanternBack[5].x = 2262.05;
		lanternBack[5].y = 592.5;
		if (lanternBack[5].scale) lanternBack[5].scale.x = 0.800;
		if (lanternBack[5].scale) lanternBack[5].scale.y = 0.800;
		if (lanternBack[5].onLayout) lanternBack[5].onLayout();
	}
	const holly = this.holly;
	if (!holly[0] && holly.elementFactory) {
		holly[0] = holly.elementFactory(0,undefined);
	}
	if (holly[0]) {
		ch9_p05_hh_ch9_72dpi_p05psdAssetchp9_p05_holly1.call(holly[0] as Ich9_p05_hh_ch9_72dpi_p05psdAssetchp9_p05_holly1);
		holly[0].x = 560.75;
		holly[0].y = 669;
		holly[0].width = 232.50;
		holly[0].height = 364.00;
		holly[0].alpha = 1;
		if (holly[0].onLayout) holly[0].onLayout();
	}
	if (!holly[1] && holly.elementFactory) {
		holly[1] = holly.elementFactory(1,undefined);
	}
	if (holly[1]) {
		ch9_p05_hh_ch9_72dpi_p05psdAssetchp9_p05_holly2.call(holly[1] as Ich9_p05_hh_ch9_72dpi_p05psdAssetchp9_p05_holly2);
		holly[1].x = 1639.75;
		holly[1].y = 669;
		holly[1].width = 232.50;
		holly[1].height = 371.00;
		holly[1].alpha = 1;
		if (holly[1].onLayout) holly[1].onLayout();
	}
	if (!holly[2] && holly.elementFactory) {
		holly[2] = holly.elementFactory(2,undefined);
	}
	if (holly[2]) {
		ch9_p05_hh_ch9_72dpi_p05psdAssetchp9_p05_holly3.call(holly[2] as Ich9_p05_hh_ch9_72dpi_p05psdAssetchp9_p05_holly3);
		holly[2].x = 2500;
		holly[2].y = 677;
		holly[2].width = 498.00;
		holly[2].height = 376.50;
		holly[2].alpha = 1;
		if (holly[2].onLayout) holly[2].onLayout();
	}
	const lanternFront = this.lanternFront;
	if (!lanternFront[0] && lanternFront.elementFactory) {
		lanternFront[0] = lanternFront.elementFactory(0,undefined);
	}
	if (lanternFront[0]) {
		ch9_p05_lanternRed.call(lanternFront[0] as Ich9_p05_lanternRed);
		lanternFront[0].x = 1181.75;
		lanternFront[0].y = 669;
		if (lanternFront[0].onLayout) lanternFront[0].onLayout();
	}
	if (!lanternFront[1] && lanternFront.elementFactory) {
		lanternFront[1] = lanternFront.elementFactory(1,undefined);
	}
	if (lanternFront[1]) {
		ch9_p05_lanternBlue.call(lanternFront[1] as Ich9_p05_lanternBlue);
		lanternFront[1].x = 830.75;
		lanternFront[1].y = 661;
		if (lanternFront[1].onLayout) lanternFront[1].onLayout();
	}
	if (!lanternFront[2] && lanternFront.elementFactory) {
		lanternFront[2] = lanternFront.elementFactory(2,undefined);
	}
	if (lanternFront[2]) {
		ch9_p05_lanternYellow.call(lanternFront[2] as Ich9_p05_lanternYellow);
		lanternFront[2].x = 1503.75;
		lanternFront[2].y = 659;
		if (lanternFront[2].onLayout) lanternFront[2].onLayout();
	}
	if (!lanternFront[3] && lanternFront.elementFactory) {
		lanternFront[3] = lanternFront.elementFactory(3,undefined);
	}
	if (lanternFront[3]) {
		ch9_p05_lanternRed.call(lanternFront[3] as Ich9_p05_lanternRed);
		lanternFront[3].x = 1823.6;
		lanternFront[3].y = 670;
		if (lanternFront[3].onLayout) lanternFront[3].onLayout();
	}
	if (!lanternFront[4] && lanternFront.elementFactory) {
		lanternFront[4] = lanternFront.elementFactory(4,undefined);
	}
	if (lanternFront[4]) {
		ch9_p05_lanternBlue.call(lanternFront[4] as Ich9_p05_lanternBlue);
		lanternFront[4].x = 2373.45;
		lanternFront[4].y = 658.4;
		if (lanternFront[4].onLayout) lanternFront[4].onLayout();
	}
	const bushes = this.bushes;
	ch9_p05_hh_ch9_72dpi_p05psdAssetbarnbushes.call(this.bushes);
	bushes.x = 3006;
	bushes.y = 674.5;
	bushes.width = 644.00;
	bushes.height = 187.00;
	bushes.alpha = 1.00;
	if (bushes.onLayout) bushes.onLayout();
	return this;
}
function ch9_p05_hh_ch9_72dpi_p05psdAssetchp9_p05_bgcopy(this: Ich9_p05_hh_ch9_72dpi_p05psdAssetchp9_p05_bgcopy) {
	if (this.setLayoutTexture) this.setLayoutTexture("chp9_p05_bgcopy", 0.500, 0.500);
	if (this.setBlendMode) this.setBlendMode("normal");
	return this;
}
function ch9_p05_hh_ch9_72dpi_p05psdAssetchp9_p05_bg(this: Ich9_p05_hh_ch9_72dpi_p05psdAssetchp9_p05_bg) {
	if (this.setLayoutTexture) this.setLayoutTexture("chp9_p05_bg", 0.500, 0.500);
	if (this.setBlendMode) this.setBlendMode("normal");
	return this;
}
function ch9_p05_lanternYellow(this: Ich9_p05_lanternYellow) {
	const shadow = this.shadow;
	ch9_p05_hh_ch9_72dpi_p05psdAssetchp9_p05_lanternshadow.call(this.shadow);
	shadow.x = -2;
	shadow.y = 23.25;
	shadow.width = 80.50;
	shadow.height = 14.50;
	shadow.alpha = 1.00;
	if (shadow.onLayout) shadow.onLayout();
	const offSprite = this.offSprite;
	ch9_p05_hh_ch9_72dpi_p05psdAssetchp9_p05_lanternyoff.call(this.offSprite);
	offSprite.x = 0.75;
	offSprite.y = -17.75;
	offSprite.width = 66.00;
	offSprite.height = 88.50;
	offSprite.alpha = 1.00;
	if (offSprite.onLayout) offSprite.onLayout();
	const onSprite = this.onSprite;
	ch9_p05_hh_ch9_72dpi_p05psdAssetchp9_p05_lanternyon.call(this.onSprite);
	onSprite.x = 0;
	onSprite.y = 0;
	onSprite.width = 113.50;
	onSprite.height = 124.00;
	onSprite.alpha = 1.00;
	if (onSprite.onLayout) onSprite.onLayout();
	return this;
}
function ch9_p05_hh_ch9_72dpi_p05psdAssetchp9_p05_lanternshadow(this: Ich9_p05_hh_ch9_72dpi_p05psdAssetchp9_p05_lanternshadow) {
	if (this.setLayoutTexture) this.setLayoutTexture("chp9_p05_lanternshadow", 0.500, 0.500);
	if (this.setBlendMode) this.setBlendMode("multiply");
	return this;
}
function ch9_p05_hh_ch9_72dpi_p05psdAssetchp9_p05_lanternyoff(this: Ich9_p05_hh_ch9_72dpi_p05psdAssetchp9_p05_lanternyoff) {
	if (this.setLayoutTexture) this.setLayoutTexture("chp9_p05_lanternyoff", 0.500, 0.500);
	if (this.setBlendMode) this.setBlendMode("normal");
	return this;
}
function ch9_p05_hh_ch9_72dpi_p05psdAssetchp9_p05_lanternyon(this: Ich9_p05_hh_ch9_72dpi_p05psdAssetchp9_p05_lanternyon) {
	if (this.setLayoutTexture) this.setLayoutTexture("chp9_p05_lanternyon", 0.500, 0.500);
	if (this.setBlendMode) this.setBlendMode("normal");
	return this;
}
function ch9_p05_lanternBlue(this: Ich9_p05_lanternBlue) {
	const shadow = this.shadow;
	ch9_p05_hh_ch9_72dpi_p05psdAssetchp9_p05_lanternshadow.call(this.shadow);
	shadow.x = -5;
	shadow.y = 23.25;
	shadow.width = 80.50;
	shadow.height = 14.50;
	shadow.alpha = 1.00;
	if (shadow.onLayout) shadow.onLayout();
	const offSprite = this.offSprite;
	ch9_p05_hh_ch9_72dpi_p05psdAssetchp9_p05_lanternboff.call(this.offSprite);
	offSprite.x = 0.25;
	offSprite.y = -17.75;
	offSprite.width = 66.00;
	offSprite.height = 88.50;
	offSprite.alpha = 1.00;
	if (offSprite.onLayout) offSprite.onLayout();
	const onSprite = this.onSprite;
	ch9_p05_hh_ch9_72dpi_p05psdAssetchp9_p05_lanternbon.call(this.onSprite);
	onSprite.x = 0;
	onSprite.y = 0;
	onSprite.width = 154.50;
	onSprite.height = 162.00;
	onSprite.alpha = 1.00;
	if (onSprite.onLayout) onSprite.onLayout();
	return this;
}
function ch9_p05_hh_ch9_72dpi_p05psdAssetchp9_p05_lanternboff(this: Ich9_p05_hh_ch9_72dpi_p05psdAssetchp9_p05_lanternboff) {
	if (this.setLayoutTexture) this.setLayoutTexture("chp9_p05_lanternboff", 0.500, 0.500);
	if (this.setBlendMode) this.setBlendMode("normal");
	return this;
}
function ch9_p05_hh_ch9_72dpi_p05psdAssetchp9_p05_lanternbon(this: Ich9_p05_hh_ch9_72dpi_p05psdAssetchp9_p05_lanternbon) {
	if (this.setLayoutTexture) this.setLayoutTexture("chp9_p05_lanternbon", 0.500, 0.500);
	if (this.setBlendMode) this.setBlendMode("normal");
	return this;
}
function ch9_p05_lanternRed(this: Ich9_p05_lanternRed) {
	const shadow = this.shadow;
	ch9_p05_hh_ch9_72dpi_p05psdAssetchp9_p05_lanternshadow.call(this.shadow);
	shadow.x = 2.5;
	shadow.y = 23.25;
	shadow.width = -80.50;
	shadow.height = 14.50;
	shadow.alpha = 1.00;
	if (shadow.onLayout) shadow.onLayout();
	const offSprite = this.offSprite;
	ch9_p05_hh_ch9_72dpi_p05psdAssetchp9_p05_lanternroff.call(this.offSprite);
	offSprite.x = -0.75;
	offSprite.y = -17.75;
	offSprite.width = 66.00;
	offSprite.height = 88.50;
	offSprite.alpha = 1.00;
	if (offSprite.onLayout) offSprite.onLayout();
	const onSprite = this.onSprite;
	ch9_p05_hh_ch9_72dpi_p05psdAssetchp9_p05_lanternron.call(this.onSprite);
	onSprite.x = 0;
	onSprite.y = 0;
	onSprite.width = 113.50;
	onSprite.height = 124.00;
	onSprite.alpha = 1.00;
	if (onSprite.onLayout) onSprite.onLayout();
	return this;
}
function ch9_p05_hh_ch9_72dpi_p05psdAssetchp9_p05_lanternroff(this: Ich9_p05_hh_ch9_72dpi_p05psdAssetchp9_p05_lanternroff) {
	if (this.setLayoutTexture) this.setLayoutTexture("chp9_p05_lanternroff", 0.500, 0.500);
	if (this.setBlendMode) this.setBlendMode("normal");
	return this;
}
function ch9_p05_hh_ch9_72dpi_p05psdAssetchp9_p05_lanternron(this: Ich9_p05_hh_ch9_72dpi_p05psdAssetchp9_p05_lanternron) {
	if (this.setLayoutTexture) this.setLayoutTexture("chp9_p05_lanternron", 0.500, 0.500);
	if (this.setBlendMode) this.setBlendMode("normal");
	return this;
}
function ch9_p05_hh_ch9_72dpi_p05psdAssetchp9_p05_holly1(this: Ich9_p05_hh_ch9_72dpi_p05psdAssetchp9_p05_holly1) {
	if (this.setLayoutTexture) this.setLayoutTexture("chp9_p05_holly1", 0.500, 1.000);
	if (this.setBlendMode) this.setBlendMode("normal");
	return this;
}
function ch9_p05_hh_ch9_72dpi_p05psdAssetchp9_p05_holly2(this: Ich9_p05_hh_ch9_72dpi_p05psdAssetchp9_p05_holly2) {
	if (this.setLayoutTexture) this.setLayoutTexture("chp9_p05_holly2", 0.500, 1.000);
	if (this.setBlendMode) this.setBlendMode("normal");
	return this;
}
function ch9_p05_hh_ch9_72dpi_p05psdAssetchp9_p05_holly3(this: Ich9_p05_hh_ch9_72dpi_p05psdAssetchp9_p05_holly3) {
	if (this.setLayoutTexture) this.setLayoutTexture("chp9_p05_holly3", 0.500, 1.000);
	if (this.setBlendMode) this.setBlendMode("normal");
	return this;
}
function ch9_p05_hh_ch9_72dpi_p05psdAssetbarnbushes(this: Ich9_p05_hh_ch9_72dpi_p05psdAssetbarnbushes) {
	if (this.setLayoutTexture) this.setLayoutTexture("barnbushes", 0.500, 0.500);
	if (this.setBlendMode) this.setBlendMode("normal");
	return this;
}
interface Ich9_p05Array<T> {
	[index: number]: T;
	elementFactory?(index:number, parameters?:any): T;
}
interface Ich9_p05Container {
	x?: number;
	y?: number;
	scale?: {x:number, y:number};
	rotation?: number;
	width?: number;
	height?: number;
	onLayout?(): void;
}
interface Ich9_p05Sprite extends Ich9_p05Container {
	setLayoutTexture?(name: string, anchorX :number, anchorY :number): void;
	alpha: number;
	setBlendMode?(blendMode: string): void;
}
interface Ich9_p05Text extends Ich9_p05Container {
	fontSize: number;
	textAreaWidth: number;
	textAreaHeight: number;
}
interface Ich9_p05Polygon extends Array<number> {
}
interface Ich9_p05 {
	readonly bg: Ich9_p05Array<Ich9_p05_hh_ch9_72dpi_p05psdAssetchp9_p05_bgcopy|Ich9_p05_hh_ch9_72dpi_p05psdAssetchp9_p05_bg>;
	readonly lanternBack: Ich9_p05Array<Ich9_p05_lanternYellow|Ich9_p05_lanternBlue|Ich9_p05_lanternRed>;
	readonly holly: Ich9_p05Array<Ich9_p05_hh_ch9_72dpi_p05psdAssetchp9_p05_holly1|Ich9_p05_hh_ch9_72dpi_p05psdAssetchp9_p05_holly2|Ich9_p05_hh_ch9_72dpi_p05psdAssetchp9_p05_holly3>;
	readonly lanternFront: Ich9_p05Array<Ich9_p05_lanternRed|Ich9_p05_lanternBlue|Ich9_p05_lanternYellow>;
	readonly bushes: Ich9_p05_hh_ch9_72dpi_p05psdAssetbarnbushes;
}
interface Ich9_p05_hh_ch9_72dpi_p05psdAssetchp9_p05_bgcopy extends Ich9_p05Sprite {
}
interface Ich9_p05_hh_ch9_72dpi_p05psdAssetchp9_p05_bg extends Ich9_p05Sprite {
}
interface Ich9_p05_lanternYellow extends Ich9_p05Container {
	readonly shadow: Ich9_p05_hh_ch9_72dpi_p05psdAssetchp9_p05_lanternshadow;
	readonly offSprite: Ich9_p05_hh_ch9_72dpi_p05psdAssetchp9_p05_lanternyoff;
	readonly onSprite: Ich9_p05_hh_ch9_72dpi_p05psdAssetchp9_p05_lanternyon;
}
interface Ich9_p05_hh_ch9_72dpi_p05psdAssetchp9_p05_lanternshadow extends Ich9_p05Sprite {
}
interface Ich9_p05_hh_ch9_72dpi_p05psdAssetchp9_p05_lanternyoff extends Ich9_p05Sprite {
}
interface Ich9_p05_hh_ch9_72dpi_p05psdAssetchp9_p05_lanternyon extends Ich9_p05Sprite {
}
interface Ich9_p05_lanternBlue extends Ich9_p05Container {
	readonly shadow: Ich9_p05_hh_ch9_72dpi_p05psdAssetchp9_p05_lanternshadow;
	readonly offSprite: Ich9_p05_hh_ch9_72dpi_p05psdAssetchp9_p05_lanternboff;
	readonly onSprite: Ich9_p05_hh_ch9_72dpi_p05psdAssetchp9_p05_lanternbon;
}
interface Ich9_p05_hh_ch9_72dpi_p05psdAssetchp9_p05_lanternboff extends Ich9_p05Sprite {
}
interface Ich9_p05_hh_ch9_72dpi_p05psdAssetchp9_p05_lanternbon extends Ich9_p05Sprite {
}
interface Ich9_p05_lanternRed extends Ich9_p05Container {
	readonly shadow: Ich9_p05_hh_ch9_72dpi_p05psdAssetchp9_p05_lanternshadow;
	readonly offSprite: Ich9_p05_hh_ch9_72dpi_p05psdAssetchp9_p05_lanternroff;
	readonly onSprite: Ich9_p05_hh_ch9_72dpi_p05psdAssetchp9_p05_lanternron;
}
interface Ich9_p05_hh_ch9_72dpi_p05psdAssetchp9_p05_lanternroff extends Ich9_p05Sprite {
}
interface Ich9_p05_hh_ch9_72dpi_p05psdAssetchp9_p05_lanternron extends Ich9_p05Sprite {
}
interface Ich9_p05_hh_ch9_72dpi_p05psdAssetchp9_p05_holly1 extends Ich9_p05Sprite {
}
interface Ich9_p05_hh_ch9_72dpi_p05psdAssetchp9_p05_holly2 extends Ich9_p05Sprite {
}
interface Ich9_p05_hh_ch9_72dpi_p05psdAssetchp9_p05_holly3 extends Ich9_p05Sprite {
}
interface Ich9_p05_hh_ch9_72dpi_p05psdAssetbarnbushes extends Ich9_p05Sprite {
}
